import {
  differenceInCalendarDays,
  addDays,
  parseISO,
  startOfDay,
} from "date-fns";
import { AppleAutocompleteResult, ViatorProductResponse } from "@/types";
import api from "@/config/axiosConfig";

export function generateDaysArray(startDate: string, endDate: string) {
  const start = parseISO(startDate);
  const end = parseISO(endDate);
  const startUTC = new Date(
    Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate())
  );
  const endUTC = new Date(
    Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate())
  );
  const numberOfDays = differenceInCalendarDays(endUTC, startUTC) + 1;

  return Array.from({ length: numberOfDays }, (_, index) => {
    const currentDate = addDays(startUTC, index);
    const utcMidnight = new Date(
      Date.UTC(
        currentDate.getUTCFullYear(),
        currentDate.getUTCMonth(),
        currentDate.getUTCDate()
      )
    );

    return {
      date: utcMidnight.toISOString(),
      items: [],
    };
  });
}

export const getMoreProductDetails = async (
  placeId: string,
  locationId: number
): Promise<ViatorProductResponse> => {
  const response = await api.experiences.get(`/viator-products`, {
    params: { place_id: placeId, location_id: locationId },
  });
  return response.data;
};

export const getMoreProductDetailsNonGeneral = async (
  place: AppleAutocompleteResult
) => {
  const response = await api.experiences.get(`/viator-products`, {
    params: {
      place_id: place,
    },
  });
  return response.data;
};
